module.exports = __webpack_public_path__ + "img/1.1952c831.png";